var a = (i, t, e) => {
  if (!t.has(i))
    throw TypeError("Cannot " + e);
};
var n = (i, t, e) => {
  if (t.has(i))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(i) : t.set(i, e);
};
var r = (i, t, e) => (a(i, t, "access private method"), e);
import { E as o } from "./Exporter-70879e53.mjs";
var s, d;
class c extends o {
  constructor(e) {
    super(e);
    n(this, s);
    r(this, s, d).call(this);
  }
}
s = new WeakSet(), d = function() {
  const e = () => {
    this.send(this.queue.getAllWithClear());
  };
  addEventListener("visibilitychange", () => {
    document.visibilityState === "hidden" && e();
  }), addEventListener("pagehide", () => {
    e();
  });
};
export {
  c as default
};
